var map = {
	"./add-square.svg": [
		5125,
		5125
	],
	"./add.svg": [
		3662,
		3662
	],
	"./arrow-right.svg": [
		8666,
		8666
	],
	"./calendar.svg": [
		6590,
		6590
	],
	"./caretRight.svg": [
		7920,
		7920
	],
	"./cart.svg": [
		8443,
		8443
	],
	"./chart.svg": [
		499,
		499
	],
	"./check-2.svg": [
		4444,
		4444
	],
	"./check.svg": [
		9391,
		9391
	],
	"./chevron-down.svg": [
		698,
		698
	],
	"./chevron-left.svg": [
		6623,
		6623
	],
	"./chevron-right.svg": [
		4326,
		4326
	],
	"./chevron-top.svg": [
		744,
		744
	],
	"./circle-tick.svg": [
		2073,
		2073
	],
	"./collapse-arrow.svg": [
		8491,
		8491
	],
	"./copy-1.svg": [
		4631,
		4631
	],
	"./copy.svg": [
		5728,
		5728
	],
	"./cross-1.svg": [
		9349,
		9349
	],
	"./cross-circle.svg": [
		263,
		263
	],
	"./cross.svg": [
		3963,
		3963
	],
	"./dashboard.svg": [
		1887,
		1887
	],
	"./dashboard_exchange.svg": [
		712,
		712
	],
	"./dashboard_forward.svg": [
		8759,
		8759
	],
	"./dashboard_orders.svg": [
		3187,
		9527
	],
	"./dashboard_reverse.svg": [
		2203,
		2203
	],
	"./document-1.svg": [
		2704,
		2704
	],
	"./document.svg": [
		2185,
		1694
	],
	"./download-1.svg": [
		4730,
		4730
	],
	"./download.svg": [
		6639,
		6639
	],
	"./draggable.svg": [
		5173,
		5173
	],
	"./edit.svg": [
		1293,
		1293
	],
	"./error-cross.svg": [
		3888,
		3888
	],
	"./expand-arrow.svg": [
		6107,
		6107
	],
	"./export.svg": [
		2038,
		2038
	],
	"./eye.svg": [
		1191,
		1191
	],
	"./filter.svg": [
		8189,
		8189
	],
	"./global-region.svg": [
		248,
		248
	],
	"./hide-password.svg": [
		6099,
		6099
	],
	"./incorrect-circle.svg": [
		7473,
		7473
	],
	"./info-circle.svg": [
		7230,
		7230
	],
	"./info.svg": [
		121,
		121
	],
	"./light-bulb.svg": [
		6497,
		6497
	],
	"./location-2.svg": [
		2929,
		2929
	],
	"./location.svg": [
		9988,
		9988
	],
	"./lock.svg": [
		7153,
		7153
	],
	"./logout.svg": [
		8278,
		8278
	],
	"./manifest.svg": [
		6316,
		6316
	],
	"./paper-upload.svg": [
		837,
		837
	],
	"./pencil.svg": [
		4585,
		4585
	],
	"./print.svg": [
		9895,
		8828
	],
	"./refresh.svg": [
		7495,
		7495
	],
	"./rounded-cross.svg": [
		2833,
		2833
	],
	"./rounded-tick.svg": [
		1922,
		1922
	],
	"./save.svg": [
		9986,
		9986
	],
	"./search.svg": [
		2702,
		2702
	],
	"./setting.svg": [
		3971,
		3971
	],
	"./settings.svg": [
		3556,
		3556
	],
	"./show-password.svg": [
		6777,
		6777
	],
	"./side-vector.svg": [
		6058,
		6058
	],
	"./spinner.svg": [
		3226,
		3226
	],
	"./success-tick.svg": [
		2393,
		2393
	],
	"./tick-square.svg": [
		1670,
		1670
	],
	"./tick.svg": [
		2807,
		2807
	],
	"./time-circle.svg": [
		1584,
		1584
	],
	"./timeCircle.svg": [
		1547,
		1547
	],
	"./trash.svg": [
		7336,
		7336
	],
	"./truck.svg": [
		494,
		494
	],
	"./upload-1.svg": [
		9971,
		9971
	],
	"./upload.svg": [
		7359,
		7359
	],
	"./users.svg": [
		2044,
		2044
	],
	"./x-circle.svg": [
		7363,
		7363
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5981;
module.exports = webpackAsyncContext;